var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component } from 'vue-property-decorator';
import UcWindow from "../../../lib/UcWindow";
import JsonView from "../../../lib/builtin/components/JSONView";
import { message } from 'ant-design-vue';
import "./PopupEditor.css";
import { ICMBPopupEditor } from "../../../lib/comps/InlineCodeMirrorBase/PopupEditor";
import { detailErrorVerbose } from "../../../lib/utils/script/evalRuntime";
let ICMBRunExprEditor = class ICMBRunExprEditor extends ICMBPopupEditor {
  constructor() {
    super(...arguments);
    this.inited = true;
    this.tempExprValue = null;
    this.tempExprError = null;
    this.displayMode = 'Raw';
    this.autoReExec = true;
  }
  exec() {
    var _error;
    const originError = window.ucWarnExpressionError;
    let error = null;
    this.tempExprError = null;
    window.ucWarnExpressionError = (...args) => {
      // @ts-ignore
      error = detailErrorVerbose(...args);
    };
    this.tempExprValue = this.owner.getRunExprRes();
    window.ucWarnExpressionError = originError;
    // @ts-ignore
    this.tempExprError = (_error = error) === null || _error === void 0 ? void 0 : _error.slice(2).map(item => {
      if (item !== null && item !== void 0 && item.code) {
        return `code : ${item.code}\n`;
      }
      return item;
    }).join('');
  }
  get modalVisible() {
    return this.owner.icmbRunExprShown;
  }
  set modalVisible(val) {
    this.owner.icmbRunExprShown = !!val;
  }
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  async init() {}
  onShowModal() {
    this.unWatchAutoExec = this.$watch(() => [this.autoReExec, this.owner.tempValue], () => {
      if (this.autoReExec) {
        this.exec();
      }
    }, {
      immediate: true
    });
  }
  onHideModal() {
    var _this$unWatchAutoExec;
    (_this$unWatchAutoExec = this.unWatchAutoExec) === null || _this$unWatchAutoExec === void 0 || _this$unWatchAutoExec.call(this);
  }
  printInConsole() {
    const getTempNameFromWindow = () => {
      let i = 0;
      while (i += 1) {
        const varName = `temp${i}`;
        if (!(varName in window)) {
          return varName;
        }
      }
    };
    const tempName = getTempNameFromWindow();
    window[tempName] = this.tempExprValue;
    message.info(`f12开启控制台 使用${tempName}访问`);
    console.log(this.tempExprValue);
  }
  get JSONString() {
    if (typeof this.tempExprValue === 'object') {
      return JSON.stringify(this.tempExprValue);
    }
    return String(this.tempExprValue);
  }
  renderContent() {
    const h = this.$createElement;
    return [h("div", {
      "class": 'ucd-icmbpe-toolbar',
      "style": 'flex-wrap: wrap;gap: 16px;align-items: center;'
    }, [h("a-radio-group", {
      "attrs": {
        "size": 'small'
      },
      "model": {
        value: this.displayMode,
        callback: $$v => {
          this.displayMode = $$v;
        }
      }
    }, [h("a-radio-button", {
      "attrs": {
        "value": 'JSONView'
      }
    }, ["JSONView"]), h("a-radio-button", {
      "attrs": {
        "value": 'Raw'
      }
    }, ["Raw"])]), h("span", {
      "style": "display: flex;align-items: center;gap:4px"
    }, [h("a-switch", {
      "attrs": {
        "size": 'small'
      },
      "model": {
        value: this.autoReExec,
        callback: $$v => {
          this.autoReExec = $$v;
        }
      }
    }), h("span", ["\u81EA\u52A8\u91CD\u65B0\u6267\u884C"])]), h("span", {
      "style": "display:flex;gap:8px;margin-left:auto;"
    }, [h("a-button", {
      "attrs": {
        "type": 'primary',
        "size": 'small'
      },
      "on": {
        "click": this.printInConsole
      }
    }, ["\u5728\u63A7\u5236\u53F0\u4E2D\u6253\u5370"]), h("a-button", {
      "attrs": {
        "icon": 'redo',
        "type": 'primary',
        "size": 'small'
      },
      "on": {
        "click": this.exec
      }
    })])]), h("div", {
      "class": 'ucd-icmbpe-container',
      "key": 'container',
      "on": {
        "keydown": this.handleKeydown
      },
      "ref": 'containerEl',
      "style": `position:relative;height:${this.height}px`
    }, [h("a-divider", {
      "style": "margin-top: 12px;"
    }), this.displayMode === 'JSONView' && h(JsonView, {
      "attrs": {
        "value": this.tempExprValue
      }
    }), this.displayMode === 'Raw' && h("div", {
      "style": "overflow-wrap:break-word"
    }, [this.JSONString]), h("a-divider"), this.tempExprError && h("a-alert", {
      "attrs": {
        "message": '表达式执行失败',
        "description": this.tempExprError,
        "type": 'error'
      }
    })])];
  }
};
ICMBRunExprEditor = __decorate([Component({
  components: {
    UcWindow
  }
})], ICMBRunExprEditor);
export { ICMBRunExprEditor };
//# sourceMappingURL=RunExprEditor.js.map
